var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssueType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5026_8597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 26.3954C0.2 25.5814 0.6 24.7674 1 24.0698C4.9 16.6279 8.7 9.18605 12.6 1.74419C13.2 0.581395 14 0 15.2 0C16.2 0.116279 16.9 0.697674 17.4 1.62791C18.1 3.02326 18.9 4.4186 19.6 5.81395C22.9 12.2093 26.2 18.6047 29.6 25C30.3 26.3954 30.2 27.7907 29.4 28.9535C28.9 29.5349 28.3 29.8837 27.6 30C27.5 30 27.3 30 27.2 30C19.1 30 11.1 30 3 30C1.9 30 1 29.5349 0.5 28.4884C0.3 28.1395 0.2 27.7907 0.1 27.3256C0 26.9767 0 26.6279 0 26.3954ZM15 27.6744C19 27.6744 23 27.6744 27 27.6744C27.2 27.6744 27.3 27.6744 27.5 27.6744C27.8 27.5581 28 27.3256 28 26.9767C28 26.7442 27.9 26.3954 27.8 26.1628C25.5 21.6279 23.1 17.093 20.8 12.5581C19.1 9.30233 17.5 6.04651 15.8 2.90698C15.7 2.67442 15.5 2.44186 15.3 2.32558C14.9 2.09302 14.6 2.32558 14.4 2.90698C10.4 10.6977 6.4 18.3721 2.3 26.1628C2.2 26.2791 2.2 26.3953 2.1 26.5116C1.9 26.9767 2.2 27.5581 2.6 27.6744C2.7 27.6744 2.9 27.6744 3 27.6744C7 27.6744 11 27.6744 15 27.6744Z",
    fill: "#06C9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1992 14.9995C16.1992 16.3948 16.0992 17.7902 16.0992 19.1855C16.0992 19.6506 15.8992 19.9995 15.4992 20.1158C15.1992 20.232 14.7992 20.232 14.4992 20.1158C14.1992 19.9995 13.9992 19.7669 13.9992 19.3018C13.8992 16.5111 13.7992 13.6041 13.6992 10.8134C13.6992 9.76693 14.3992 9.18553 15.3992 9.41809C16.0992 9.53437 16.3992 9.99948 16.3992 10.8134C16.2992 12.0925 16.1992 13.6041 16.1992 14.9995Z",
    fill: "#06C9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 23.2529C13.5996 22.3227 14.1996 21.625 14.9996 21.625C15.6996 21.625 16.3996 22.3227 16.3996 23.2529C16.3996 24.1831 15.7996 24.8808 14.9996 24.8808C14.2996 24.8808 13.5996 24.1831 13.5996 23.2529Z",
    fill: "#06C9F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5026_8597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueType);
export default __webpack_public_path__ + "static/media/issueType.e8352c92697ebdb4f2880398625c3717.svg";
export { ForwardRef as ReactComponent };